/* eslint-disable no-undef */
import React, {Component} from 'react';
import Helmet from 'react-helmet';
import {Link} from 'react-router-dom';
import Header from '../../components/Layout/Header';
import TitleLoader from '../../components/TitleLoader';
import Breadcrumb from './Breadcrumb';
import Content from './Content';
import Alert from './Alert';
import Footer from '../../components/Layout/Footer';
import WhatsApp from '../../components/Layout/Whatsapp';
import Services from "./Services";

export default class PropertyDetails extends Component {
    constructor(props) {
        super(props);
        this._services = new Services();
    }

    state = {
        imovel: {tituloDetalhes:'...', imagens:[]},
        loadingContent: true
    }

    componentDidMount(){
        this.handleLoadImovel();
        window.scrollTo(0, 0);
    }
    
    handleLoadImovel = async(codigo = this.props.match.params.codigo, slug = this.props.match.params.slug) => {
        window.scrollTo(0, 0);
        this.setState({loadingContent: true});
        await this._services.getDetalhesImovel(this.props.match.params.modalidade.toLowerCase(), this.props.match.params.codigo).then(
            response => {
                if (response.hasOwnProperty('imovel')) {
                    this.setState({
                        imovel: response.imovel,
                        loadingContent: false
                    });
                } else {
                    this.setState({imovel: {id: null}, loadingContent: false});
                }

                this.setState({myloader: false})
            }
        )

        this.props.history.push(`/detalhes/${this.props.match.params.modalidade.toLowerCase()}/${codigo}${slug !== undefined ? `/${slug}`: ''}`);
    }

    render(){
        return (
            <>
                <Helmet>
                    <title>{`${this.props.match.params.modalidade.toLowerCase() === "aluguel" ? this.state.imovel.tituloTextoDestaque : this.state.imovel.tituloDetalhes} | ${process.env.REACT_APP_NAME}`}</title>
                    <meta name="title" content={this.props.match.params.modalidade.toLowerCase() === "aluguel" ? this.state.imovel.tituloTextoDestaque : this.state.imovel.tituloDetalhes} />
                    <meta name="description" content={this.state.imovel.descricao} />

                    <meta property="og:type" content="website" />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:title" content={this.props.match.params.modalidade.toLowerCase() === "aluguel" ? this.state.imovel.tituloTextoDestaque : this.state.imovel.tituloDetalhes} />
                    <meta property="og:description" content={this.state.imovel.descricao} />
                    <meta property="og:image" content={this.state.imovel.imagens !== undefined && this.state.imovel.imagens.length  > 0 ? this.state.imovel.imagens[0].imagem : ''} />
                    
                    <meta property="twitter:card" content="summary_large_image" />
                    <meta property="twitter:url" content={window.location.href} />
                    <meta property="twitter:title" content={this.props.match.params.modalidade.toLowerCase() === "aluguel" ? this.state.imovel.tituloTextoDestaque : this.state.imovel.tituloDetalhes} />
                    <meta property="twitter:description" content={this.state.imovel.descricao} />
                    <meta property="twitter:image" content={this.state.imovel.imagens !== undefined && this.state.imovel.imagens.length > 0 ? this.state.imovel.imagens[0].imagem : ''} />
                </Helmet>
                <Header />
                <main style={{minHeight: '80vh'}}>
                    {this.state.imovel.id ? 
                        <>
                            <Breadcrumb
                                loadingContent={this.state.loadingContent}
                                modalidade={this.state.imovel.modalidade}
                                tipo={this.state.imovel.tipo}
                                cidade={this.state.imovel.cidade}
                                bairro={this.state.imovel.bairro}
                                estado={this.state.imovel.estado}
                                titulo={this.state.imovel.tituloDetalhes}
                            />

                            <Content imovel={this.state.imovel} loadingContent={this.state.loadingContent} />
                            <Alert/>
                        </>

                        :

                        (this.state.loadingContent ? <TitleLoader/> :
                            <div className="container">
                                <div id="card-code-error">
                                    <h1>
                                        <i className="fa fa-unlink"></i>
                                        Oops! Imóvel não encontrado.
                                    </h1>
                                    <p>
                                        Não encontramos o imóvel de código <strong>{this.props.match.params.codigo.toUpperCase()}</strong> que você está procurando.&nbsp;
                                        Pode ser que você tenha digitado o código do imóvel incorretamente.
                                    </p>
                                    <Link to={'/'}>                        
                                        Clique aqui para volta e realizar nova busca &nbsp;
                                        <i className="fa fa-rotate-left"></i>
                                    </Link>
                                </div>
                            </div>
                        )                        
                    }
                </main>
                <WhatsApp/>
                <Footer />
            </>
        );
    }
}